module.exports = __webpack_public_path__ + "static/media/lamp-ico-white.32a290c7.svg";